import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthStore } from './services/auth.store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private router: Router, private authStore: AuthStore) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url;
    this.authStore.state.redirectUrl = url;
    if (!this.authStore.state.isLoggedIn) {
      const expiresAt = moment(JSON.parse(localStorage.getItem('expiration')));
      const token = {
        accessToken: localStorage.getItem('access'),
        refreshToken: localStorage.getItem('refresh'),
        expirationDate: expiresAt,
      };
      this.authStore.state.token = token;
      return this.authStore.refreshToken().pipe(
        switchMap(() => {
          return this.authStore.reloadAccountInfo().pipe(
            map(() => {
              return true;
            })
          );
        }),
        catchError((error: HttpErrorResponse) => {
          this.router.navigate(['./login']);
          return of(false);
        })
      );
    } else {
      return of(this.checkLogin(url));
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    const isLoggedIn = this.checkLogin(url);
    return isLoggedIn;
  }

  canLoad(route: Route): Observable<boolean> {
    const url = `/${route.path}`;
    this.authStore.state.redirectUrl = url;
    if (!this.authStore.state.isLoggedIn) {
      const expiresAt = moment(JSON.parse(localStorage.getItem('expiration')));
      const token = {
        accessToken: localStorage.getItem('access'),
        refreshToken: localStorage.getItem('refresh'),
        expirationDate: expiresAt,
      };
      this.authStore.state.token = token;
      return this.authStore.refreshToken().pipe(
        switchMap(() => {
          return this.authStore.reloadAccountInfo().pipe(
            map(() => {
              return true;
            })
          );
        }),
        catchError((error: HttpErrorResponse) => {
          this.router.navigate(['./login']);
          return of(false);
        })
      );
    } else {
      return of(this.checkLogin(url));
    }
  }

  checkLogin(url: string): boolean {
    if (!this.authStore.state.isLoggedIn) {
      this.authStore.state.redirectUrl = url;
      if (!this.authStore.checkTokenInLocalStorage()) {
        this.router.navigate(['./login']);
      }
      return false;
    }
    const urlWithoutParams = url.indexOf('?') === -1 ? url : url.substring(0, url.indexOf('?'));
    const targetUrl = urlWithoutParams; //this.authStore.resolveAuthorizedUrl(urlWithoutParams);
    /*  if (targetUrl === '') {
       this.router.navigate(['./not-found'], {skipLocationChange: true});
       return false;
     }*/
    if (targetUrl !== urlWithoutParams) {
      this.router.navigateByUrl(targetUrl);
    }
    return true;
  }
}
